module.exports = __webpack_public_path__ + "static/media/Lato-Italic.5d22f337.ttf";